/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfContractSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type PaginatedListOfContractSummary, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/contracts
 */
export interface ContractsRequestBuilder extends BaseRequestBuilder<ContractsRequestBuilder> {
    /**
     * GetContractsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfContractSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ContractsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfContractSummary | undefined>;
    /**
     * GetContractsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ContractsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetContractsByCustomer
 */
export interface ContractsRequestBuilderGetQueryParameters {
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const ContractsRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/contracts{?PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ContractsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ContractsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ContractsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfContractSummaryFromDiscriminatorValue,
        queryParametersMapper: ContractsRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
